<template>
  <div class="bg-secondary messageSMS">
    <!-- Header -->
    <b-navbar type="dark" variant="white" class="p-2 sticky" sticky>
      <span v-if="!loading" class="navbar-brand">
        <img v-if="companyLogo || appLogo" :src="logo" />
        <span> {{ clientName }}</span>
      </span>
    </b-navbar>
    <!-- Page content -->
    <div class="container container bg-secondary mt-4">
      <div v-if="!loading" class="row justify-content-center">
        <div class="col-lg-12 col-md-12 cols-12">
          <!-- <div class="center_div_container">
            <a v-if="!isSecondaryChannel" :href="signupURL">
              <div class="row app_buttons_container">
                <p class='small_text'>For the best experience <br> Click to install our mobile app!</p>
                <div class="icons" v-if="signupURL">
                  <i class="app_icon fa fa-apple" aria-hidden="true"></i>
                  <img class="imgicon" src="/img/icons/common/gplayicon.svg" />
                </div>
              </div>
            </a>
          </div> -->
          <h2 v-if="type === 'Regular Message' && message.message" class="mt-4">Message:</h2>
          <h3 v-if="title" class="mt-4 text-center">{{ title }}</h3>
          <div class="row mb-3">
            <div v-if="messageDescription" class="w-100 text-center">
              <div class="message-content">{{ messageDescription }}</div>
            </div>
          </div>
          <div class="row">
            <div v-if="message.message" class="w-100 text-center">
              <div class="message-content" v-html="message.message"></div>
            </div>
          </div>
          <div v-if="file" class="row">
            <div class="w-100 text-center px-3">
              <a :href="file" target="_blank" class="w-100 btn btn-primary">Open File <i class="fas fa-external-link-alt"></i></a>
            </div>
          </div>

          <div v-if="type === 'Vocast' && url" class="row">
            <div id="audio" class="player-wrapper">
              <audio-player :file="url" :has-volume="false"></audio-player>
            </div>
          </div>

          <div v-if="type === 'Vidcast' && url" class="row">
            <div id="video" class="player-wrapper">
              <Media :kind="'video'" :is-muted="false" :src="[url]" :controls="true" :loop="true" width="100%"></Media>
            </div>
          </div>

          <ul v-if="hasReadReceipt || hasFeedback" class="list-group list-group-flush mt-4" data-toggle="checklist">
            <li v-if="hasReadReceipt" class="list-group-item px-0">
              <div class="checklist-item checklist-item-secondary">
                <div class="checklist-info">
                  <h5 class="checklist-title mb-0">I confirm that I have read and understood this message</h5>
                </div>
                <div>
                  <div class="custom-control custom-checkbox custom-checkbox-primary">
                    <input
                      id="1eafcc6922e66"
                      v-model="readResponse"
                      class="custom-control-input"
                      value="1"
                      type="checkbox"
                      :disabled="readResponse == 1"
                      @click="updateReadStatus" />
                    <label for="1eafcc6922e66" class="custom-control-label"></label>
                  </div>
                </div>
              </div>
            </li>
            <li v-if="hasFeedback" class="list-group-item px-0 pb-0 mb-0">
              <div class="checklist-item checklist-item-secondary">
                <div class="checklist-info">
                  <h5 class="checklist-title mb-0">Feedback/Comment (Private - shared with sender only)</h5>
                </div>
                <div>
                  <div class="custom-control custom-checkbox custom-checkbox-success">
                    <input id="1eafcc6922e67" v-model="feedbackYes" class="custom-control-input" value="1" type="checkbox" />
                    <label for="1eafcc6922e67" class="custom-control-label">
                      <img src="/img/assets/yes.png" height="20px" />
                    </label>
                  </div>
                  <div class="custom-control custom-checkbox custom-checkbox-danger mt-1">
                    <input id="1eafcc6922e68" v-model="feedbackNo" class="custom-control-input" value="0" type="checkbox" />
                    <label for="1eafcc6922e68" class="custom-control-label">
                      <img src="/img/assets/no.png" height="20px" />
                    </label>
                  </div>
                </div>
              </div>
              <div>
                <form role="form">
                  <input
                    id="feedbackComment"
                    v-model.trim="feedbackComment"
                    name="feedbackComment"
                    class="mt-3 form-control"
                    prepend-icon="fas fa-envelope"
                    type="input"
                    placeholder="Enter your comment" />
                  <button class="btn btn-primary w-100 mt-3" @click.prevent="sendFeedback">Submit Feedback</button>
                </form>
              </div>
            </li>
          </ul>
          <button class="btn btn-default w-100 mt-3" @click="showMemberBenefits">Member Benefits</button>
          <b-collapse id="member-benefits" v-model="memberBenefitShow" class="mt-4">
            <h2 v-if="packages.links.length > 0" class="mt-1">Member Benefits:</h2>
            <ul v-if="packages.links.length > 0" class="list-group list-group-flush">
              <li v-for="(item, i) in packages.links" :key="i" class="list-group-item px-0">
                <a :href="hasProtocol(item.link)" target="_blank">
                  <b-row>
                    <b-col cols="4">
                      <img :src="item.image" class="w-100" />
                    </b-col>
                    <b-col cols="8">
                      <h3 class="w-100">{{ item.title }}</h3>
                      <span class="w-100">{{ item.description }}</span>
                    </b-col>
                  </b-row>
                </a>
              </li>
            </ul>
          </b-collapse>
        </div>
      </div>
      <div v-if="loading" class="row justify-content-center">
        <b-row>
          <div class="col-lg-12 text-center">
            <pulse-loader :color="'#3867d6'"></pulse-loader>
          </div>
        </b-row>
      </div>
    </div>
  </div>
</template>
<script>
import Media from '@dongido/vue-viaudio';
import { NotificationTypes, wrapNotification } from '@/utils/notification';

export default {
  name: 'RegisterSMS',
  components: {
    Media,
  },
  data() {
    return {
      companyName: '',
      companyLogo: null,
      channelName: '',
      appLogo: null,
      companyCopyright: '',
      packages: {
        links: [],
      },
      hasReadReceipt: false,
      hasFeedback: false,
      feedbackComment: '',
      feedbackYes: null,
      feedbackNo: null,
      message: {
        message: '',
      },
      title: null,
      file: null,
      messageDescription: null,
      companyInfo: null,
      readResponse: 0,
      signupURL: false,
      isSecondaryChannel: false,
      messageID: null,
      userID: null,
      channelID: null,
      url: null,
      type: null,
      memberBenefitShow: false,
    };
  },
  computed: {
    logo: {
      get: function () {
        return this.appLogo || this.companyLogo;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    clientName: {
      get: function () {
        return this.channelName || this.companyName;
      },
      set: function (newValue) {
        return newValue;
      },
    },
    loading() {
      return this.$store.state.messages.smsMessageLoading;
    },
  },
  watch: {
    feedbackYes: function (value) {
      if (value && value != null) {
        this.feedbackNo = null;
      }
    },
    feedbackNo: function (value) {
      if (value && value != null) {
        this.feedbackYes = null;
      }
    },
  },
  beforeMount() {
    const companyID = this.$route.params.companyID;
    const token = this.$route.params.token;
    this.getSMSMessage(token);
  },
  methods: {
    getSMSMessage(token) {
      this.$store
        .dispatch('messages/GET_SMS_MESSAGE', token)
        .then((resp) => {
          const data = resp.data.data;
          this.channelName = data.channelName || data.message.givenName;
          this.appLogo = data.appLogo;
          this.message = data.message;
          this.companyInfo = data.companyInfo;
          this.packages = data.packages;
          if (this.message) {
            this.hasFeedback = this.message.enableFeedback === 1;
            this.hasReadReceipt = this.message.isReadRequired === 1;

            this.messageID = this.message._id;
            this.userID = this.message.userid;
            this.feedbackYes = this.message.feedback === 1 ? '1' : null;
            this.feedbackNo = this.message.feedback === 0 ? '0' : null;
            this.feedbackComment = this.message.feedbackComment;
            this.readResponse = this.message.readResponse;
            this.url = this.message.url;
            this.type = this.message.type;
            this.title = this.message.title;
            this.messageDescription = this.message.push_message;
            this.file = this.message.html_file;
          }

          if (this.companyInfo) {
            this.companyName = this.companyInfo.name;
            this.companyLogo = this.companyInfo.logo;

            const value = `${process.env.VUE_APP_FRONTEND_URL}/${this.companyInfo.companyID}/${data.inviteID}`;
            this.signupURL = value;
            this.isSecondaryChannel = data.isSecondaryChannel;

            var faviconIcon = this.companyInfo.favicon + '?=' + Math.random() || '/favicon.ico';
            var favicon = document.querySelectorAll('.favicon');
            for (var i = 0; i < favicon.length; i++) {
              favicon[i].href = faviconIcon;
            }

            document.title = this.companyInfo.name;

            var copyright = this.companyInfo.copyright;

            if (copyright && copyright.value) {
              this.companyCopyright = copyright.message;
            }
          }
          this.readMessage();
        })
        .catch((err) => {
          console.error(err);
        });
    },
    readMessage() {
      this.$store
        .dispatch('messages/UPDATE_SMS_MESSAGE_STATUS', this.messageID)
        .then((resp) => {})
        .catch((err) => {
          console.error(err);
        });
    },
    sendFeedback(e) {
      var feedbackItems = {
        messageID: this.messageID,
        feedback: this.feedbackYes ? 1 : 0,
        comment: this.feedbackComment,
      };
      this.$store
        .dispatch('messages/UPDATE_SMS_MESSAGE_FEEDBACK', feedbackItems)
        .then((resp) => {
          if (resp.data.success) {
            wrapNotification(
              this.$notify,
              NotificationTypes.Success,
              this.$options.filters.capitalizeWords('Your feedback/comment was successfully submitted')
            );
          } else {
            wrapNotification(
              this.$notify,
              NotificationTypes.Error,
              this.$options.filters.capitalizeWords('There is an error submitting your feedback/comment')
            );
          }
        })
        .catch((err) => {
          console.error(err);
          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('There is an error submitting your feedback/comment'));
        });
    },
    getFileType(filename) {
      var type = filename.split('.');
      return type[1] || 'wav';
    },
    capitalizeWords(value) {
      return value.toUpperCase();
    },
    updateReadStatus() {
      this.$store
        .dispatch('messages/UPDATE_SMS_MESSAGE_READ', this.messageID)
        .then((resp) => {
          if (resp.data.success) {
            wrapNotification(this.$notify, NotificationTypes.Success, this.$options.filters.capitalizeWords('Your confirmation was successfully submitted'));
          } else {
            wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('There is an error submitting your confirmation'));
          }
        })
        .catch((err) => {
          console.error(err);
          wrapNotification(this.$notify, NotificationTypes.Error, this.$options.filters.capitalizeWords('There is an error submitting your feedback/comment'));
        });
    },
    hasProtocol(link) {
      const hasHttp = link.indexOf('http://') === 0 || link.indexOf('https://') === 0;
      return !hasHttp ? `http://${link}` : link;
    },
    showMemberBenefits() {
      if (this.memberBenefitShow) {
        this.memberBenefitShow = false;
      } else {
        this.memberBenefitShow = true;
        setTimeout(() => {
          document.getElementById('footer-main').scrollIntoView({ behavior: 'smooth', block: 'center' });
        }, 200);
      }
    },
  },
};
</script>
<style lang="scss">
.messageSMS {
  min-height: 736px;
  height: 812px;
}

span.navbar-brand {
  span {
    color: #000;
  }

  img {
    height: 60px;
  }
}

.message-content {
  h2 {
    padding-left: 15px;
    padding-right: 15px;
  }

  a {
    color: #5867dd;
  }

  .image {
    img {
      width: 100% !important;
    }
  }
}

.player-wrapper {
  margin: 0 auto;
}

.app_buttons_container {
  display: flex;
  flex-direction: column;
  background: #4f4e4e;
  border-radius: 15px;
  color: white;
  padding: 2% 2% 2% 2%;
  text-align: center;
  width: fit-content;
  align-content: center;
  padding-left: 5vw;
  padding-right: 5vw;
}

.center_div_container {
  display: flex;
  justify-content: center;
  margin: 5%;
  width: 65%;
  margin: auto;
}

.app_icon {
  color: white;
  font-size: 2.5rem;
  margin-left: 5%;
  margin-right: 5%;
  align-self: baseline;
}

.imgicon {
  height: 2.3rem;
  width: 2.5rem;
}

img {
  vertical-align: middle;
  border-style: none;
}

.small_text {
  width: 100%;
  font-weight: bold;
  font-size: 0.8rem;
  margin-bottom: 0;
}

.icons {
  display: flex;
  justify-content: space-around;
}
</style>
